import { submitUserConsent } from "../../../api/regulatory/regulatoryUserconsent.service"
import { SUBMIT_USER_CONSENT } from "../actionTypes"

const Request = ()=>({type: SUBMIT_USER_CONSENT.REQUEST})
const Failure = (error)=>({type: SUBMIT_USER_CONSENT.FAILURE, error})
const Success = (obj)=>({type: SUBMIT_USER_CONSENT.SUCCESS, obj})

export const userConsent = (payload)=>{
    return (dispatch, getState)=>{        
        dispatch(Request())
        return submitUserConsent(payload)  
        .then(response => {            
            dispatch(Success(response))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(Failure(error?.message))
            return Promise.resolve(false)
        })
    }
}